module.exports = "/static/media/drop.baa208f4.svg";